export default __webpack_public_path__ + "static/media/Group 5839.eba1a047.svg";